import { render, staticRenderFns } from "./customerEventLog.vue?vue&type=template&id=2a05bc0c"
import script from "./customerEventLog.ts?vue&type=script&lang=js&external"
export * from "./customerEventLog.ts?vue&type=script&lang=js&external"
import style0 from "./customerEventLog.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports